import { initial as zoomConfig } from '../../../config/zoom';
import { IViewerStoreInjector, TYPES, appContainer } from '../../../inversify.config';
import { adjustScrollForCenteredZoom } from '../zoom-utils';

/**
 * Zooms in centered on the viewport center
 * This is for keyboard shortcuts where there's no cursor position
 */
const zoomCenteredOnViewport = (newZoom: number) => {
  const viewerStore = appContainer.get<IViewerStoreInjector>(TYPES.Store.Viewer);
  const { setZoom, zoom: currentZoom, pageMode } = viewerStore.getState();

  // Only adjust scroll for single page mode
  if (pageMode === 'single') {
    adjustScrollForCenteredZoom(currentZoom, newZoom);
  }

  setZoom(newZoom);
};

export const zoomInShortcut = {
  key: new Set(['Control', 'Plus']),
  callBackFunction: () => {
    const { zoom, setViewOptions } = appContainer
      .get<IViewerStoreInjector>(TYPES.Store.Viewer)
      .getState();

    if (zoom >= zoomConfig.maxZoom) return;

    setViewOptions(null);
    const newZoom = zoom + zoomConfig.zoomStep;

    zoomCenteredOnViewport(newZoom);
  },
};
